"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Schedule = void 0;
/**
 * A container for slots of time that may be available for booking appointments.
 */
var Schedule = /** @class */ (function () {
    function Schedule() {
    }
    return Schedule;
}());
exports.Schedule = Schedule;
